import { DigitalWalletType } from '.';

export class DigitalWalletPaymentPlanDetails {
	authenticationPaymentToken: string;
	digitalWalletType: DigitalWalletType;
	isCreditCard: boolean;
	isDebitCard: boolean;
	accountName?: string;
	calculatedServiceFee?: number;
	customFields?: Array<string>;
	addressLine1: string;
	billingCity: string;
	billingState: string;
	zipCode: string;
	phoneNumber: string;
	phoneNumberIsMobile: boolean;
	email: string;
	isThirdParty: boolean;
	saveToWallet: boolean;
	numberOfPayments: number;
	paymentAmount: number;
	serviceFee: number;
	firstPaymentDate: any;
	maxRetries: number;
	isRehab: boolean;
	description: string;
	discountAmount?: number;
}
